import styled from '@emotion/styled';
import { IconButton, Button } from 'components/Buttons';
import { ArrowDirection } from 'components/Elements/HorizontalScroll/HorizontalScroll';
import { pxToEm, theme, palette, hexToRGBA } from 'theme';
export const Wrapper = styled.div``;

export const Viewport = styled.div<{ isActive: boolean }>`
  position: absolute;
  left: ${({ isActive }) => (isActive ? 0 : pxToEm(560))};
  width: 100%;
  display: flex;
  transition: left 0.5s ease;

  ${theme.breakpoints.down('md')} {
    position: relative;
    left: auto;
  }
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  touch-action: pan-y;
`;

export const FullScreenButton = styled(IconButton)`
  position: absolute;
  right: ${pxToEm(20)};
  bottom: ${pxToEm(12)};
  z-index: 2;
  background-color: ${hexToRGBA(palette.common.black, 0.4)};
  color: ${palette.common.white};
  opacity: 0;
  transition: opacity 0.2s ease;
  padding: 0;
`;

export const SaveToBoardButton = styled(Button)`
  position: absolute;
  right: ${pxToEm(20)};
  top: ${pxToEm(12)};
  z-index: 2;
  opacity: 0;
  transition: opacity 0.2s ease;
`;

export const Item = styled.div`
  padding: 0 ${pxToEm(8)};
  flex: none;
  cursor: pointer;
  position: relative;

  &:hover ${FullScreenButton}, &:hover ${SaveToBoardButton} {
    opacity: 1;
  }

  ${theme.breakpoints.down('md')} {
    padding: 0 ${pxToEm(4)};
  }

  img {
    border-radius: ${pxToEm(20)};
    height: ${pxToEm(320)};
    width: auto;

    ${theme.breakpoints.down('md')} {
      height: ${pxToEm(150)};
    }
  }
`;

type DirectionProps = { direction: ArrowDirection; show?: boolean };

export const Arrow = styled.div<DirectionProps>`
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  opacity: ${({ show }) => (show ? 1 : 0)};
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  right: ${({ direction }) =>
    direction === ArrowDirection.RIGHT ? pxToEm(10) : 'auto'};
  left: ${({ direction }) =>
    direction === ArrowDirection.LEFT ? pxToEm(10) : 'auto'};
  top: 0;
  z-index: 2;
  transition: all 0.1s linear;
  pointer-events: none;

  ${theme.breakpoints.down('md')} {
    display: none;
  }

  & button {
    width: ${pxToEm(48)};
    height: ${pxToEm(48)};
    font-size: 1em;
    background: ${palette.secondary?.main} !important;
    color: ${palette.primary.main} !important;
    pointer-events: auto;
    box-shadow: ${theme.shadows[3]};

    &:focus,
    &:active {
      color: ${palette.primary.main} !important;
      background: ${palette.secondary?.main} !important;
    }
  }
`;
